import { Button, LoadingDots, TextBase, TextSubHeader } from '@carboncopyco/ui';

interface RecordingUpdateModalProps {
  onClose: () => void;
  previewSavedRecording: () => void;
  isLoading?: boolean;
}
export const RecordingUpdateModal = ({
  isLoading,
  onClose,
  previewSavedRecording,
}: RecordingUpdateModalProps) => {
  return (
    <div className="flex flex-col">
      <div>
        <div className="mb-5">
          <TextSubHeader
            color="text-ds-natural-600"
            label="Update saved"
          />
        </div>
        <TextBase
          color="text-ds-natural-400"
          label="Preview your clone or exit the cloner to finish."
        />
        <div className="flex justify-end mt-5">
          {isLoading ? (
            <LoadingDots />
          ) : (
            <>
              <div className="mx-2">
                <Button
                  onClick={previewSavedRecording}
                  secondary
                  label="Preview"
                />
              </div>
              <div>
                <Button
                  onClick={onClose}
                  label="Exit cloning"
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
